import taskService from 'resources/task/task.service';
import documentService from 'resources/document/document.service';
import * as taskHelpers from 'resources/task/task.helpers';


export const reorderMilestoneTasks = async ({ milestoneId, tasks }) => {
  const dr = tasks.filter((t) => taskHelpers.isDocumentRequest(t));
  const otherTasks = tasks.filter((t) => !taskHelpers.isDocumentRequest(t));

  await Promise.all(dr.map(async (d) => {
    await taskService.updateTask({
      id: d.id,
      milestone_id: milestoneId,
      milestone_order: -1,
    });
  }));

  for (const [index, task] of otherTasks.entries()) {
    await taskService.updateTask({
      id: task.id,
      milestone_id: milestoneId,
      milestone_order: index,
    });
  }
};

export const extendTasksWithDocuments = async (tasks) => {
  const taskIds = tasks.map((task) => task.id);
  const documents = await documentService.getByTaskIds(taskIds) || [];

  return tasks.map((task) => {
    const taskDocuments = documents.filter((doc) => doc.task_id === task.id);
    return { ...task, tempFiles: taskDocuments.length ? taskDocuments : null };
  });
};
